const getCustomerDetails = (details)=>{
    if (!details) {
        return undefined;
    }
    const { email , phone  } = details;
    return {
        email,
        phone: phone !== null && phone !== void 0 ? phone : ''
    };
};

export { getCustomerDetails };
//# sourceMappingURL=get-customer-details.js.map
